module.exports = __webpack_public_path__ + "img/M6.7e5afc92.jpg";